import { Loader } from '@googlemaps/js-api-loader';
import { GOOGLE_MAP_KEY } from './googleMapKey';

let _loadPromise = null;

/**
 * Google Maps JS API yükleyici (tek sefer, paylaşılan promise).
 * `.load()` bazı js-api-loader sürümlerinde places/geometry'yi window.google.maps'e KOYMUYOR;
 * bu yüzden importLibrary ile yerel kütüphaneleri AÇIKÇA yüklüyoruz (window.google.maps.places garanti).
 * Hata olursa (API etkin değil / referrer) konsola net basar.
 */
export const LoadScript = () => {
    if (_loadPromise) return _loadPromise;

    const loader = new Loader({
        apiKey: GOOGLE_MAP_KEY,
        version: 'weekly',
        libraries: ['places', 'geometry', 'drawing'],
    });

    _loadPromise = (async () => {
        try {
            await loader.load();
            // Kütüphaneleri açıkça içe aktar (window.google.maps.places / geometry garanti)
            if (typeof loader.importLibrary === 'function') {
                await Promise.all([
                    loader.importLibrary('maps'),
                    loader.importLibrary('places'),
                    loader.importLibrary('geometry'),
                ]);
            }
            const ok = !!(window.google && window.google.maps);
            if (!ok) console.error('Google Maps yüklendi ama window.google.maps yok.');
            return ok;
        } catch (e) {
            console.error('Google Maps yüklenemedi (API etkin mi / anahtar kısıtı?):', e);
            _loadPromise = null; // tekrar denenebilsin
            return false;
        }
    })();

    return _loadPromise;
};
